// Validates that input value does not only include whitespace
import { ValidatorFn, AbstractControl } from '@angular/forms';

export function noWhitespaceValidator(pattern: RegExp = /\S/): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const test = pattern.test(control.value);
    return test ? null : {noWhitespace: {value: control.value}};
  };
}
